import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col, Button, Modal } from 'react-bootstrap';


function ReportDados({ dados }) {

    const [showModal, setShowModal] = useState(false);
    const [activeData, setActiveData] = useState();
    const [titleModal, setTitleModal] = useState('');

    let count = 0;

    // const types = [
    //     'Destinador Resíduos no RAPP do CTF/IBAMA',
    //     'Armazenador de Resíduos no RAPP do CTF/IBAMA',
    //     'Gerador Resíduos no RAPP do CTF/IBAMA',
    //     'Devedores de Tributos Federais listados pela Procuradoria-Geral da Fazenda Nacional (PGFN)',
    //     'Efluentes no RAPP do CTF/IBAMA',
    //     'Cadastro Técnico Federal de Atividades Potencialmente Poluidoras | IBAMA',
    //     'Acidentes do Trabalho Registrados por CAT no INSS',
    //     "Devedores de Contribuição Previdenciária listados pela Procuradoria-Geral da Fazenda Nacional (PGFN)",
    //     "Consulta de Decisões de Outorga de Direito de Uso de Recursos Hídricos",
    //     "Consulta de Termo de Ajustamento de Conduta",
    //     "Exploração Madeira no RAPP do CTF/IBAMA",
    //     "Fonte Energética no RAPP do CTF/IBAMA",
    //     "Auto de Infração Ambiental | IBAMA",
    //     "Investigações e Inquéritos | Ministério Público do Trabalho",
    //     "Licenciamento Ambiental",
    //     "Efluentes Atmosféricos no RAPP do CTF/IBAMA",
    //     "Intervenção Ambiental",
    //     "Cadastro Técnico Federal de Atividades e Instrumentos de Defesa Ambiental | IBAMA",
    //     "Consulta e Requerimento de Audiência Pública"
    // ]

    const handleClickInfo = (data, title, index) => {
        setActiveData(data);
        setTitleModal(title);
        setShowModal(true);
    }

    return (
        <>
            <Row className='scrollbar d-flex' style={{ height: 'calc(100vh - 480px)' }}>
                {dados['Dados'] && Object.keys(dados['Dados']).length > 0 && Object.keys(dados['Dados']).map((key, index) =>
                (
                    
                    <Col key={key + index} md={4}>
                        <div className='rect-content-risks' style={{ height: '116px' }}>
                            <p className='rect-tx-1'>{++count}. {key}</p>
                            <div className='rect-link cursor-pointer' style={{ top: '65px' }} onClick={() => handleClickInfo(dados['Dados'][key], key)}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    </Col>
                    
                ))}
                {count === 0 && <Row><span className="fs-6">Nenhum dado encontrado</span></Row>}
            </Row>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Dados</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeData && (
                        <>
                            <p className='rect-tx-1 fs-5' title={titleModal}>{titleModal}</p>
                            {activeData && activeData.length > 0 && activeData.map((item, i) => (
                                <div key={item + i} className='mb-5'>
                                    {item && Object.keys(item).length > 0 && Object.keys(item).map((key, j) => (
                                        key === 'Ano de Referência'
                                            || key === 'Data de Referência'
                                            || key === 'Data da Emissão do CAT'
                                            || key === 'Data da Inscrição'
                                            || key === 'Unidade Administrativa'
                                            || key === 'Procuradoria Regional do Trabalho'
                                            || key === 'Ano da Referência'
                                            || key === 'Atividade'
                                            || key === 'Órgão Autorizador'
                                            || key === 'Número do Auto de Infração Ambiental'
                                            || key === 'Portaria'
                                            || key === 'Data da Publicação da Portaria'
                                            ? <div className='mb-2 color-tertiary'><b>{key}</b>: {item[key]}</div> :
                                        <div key={key+j}><b>{key}</b>: {item[key]}</div>
                                    ))}
                                </div>
                            ))}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ReportDados;